<template>
  <div>
    <div class="page-block__inner">
      <div class="my-release-list">
        <h3
          v-if="items.length"
          class="page-block__title">
          <span v-if="items[0].status === 'active'">有効</span>
          <span v-else-if="items[0].status === 'inactive'">無効</span>
          <span v-else-if="items[0].status === 'potential'">可能性のある申し立て</span>
          -{{ title }} ({{ items.length }})
        </h3>
        <table
          class="youtube-list__table">
          <thead class="youtube-list__thead">
            <tr>
              <th class="youtube-claim-request-list__cell-asset">アセット</th>
              <th class="youtube-claim-request-list__cell-isrc">ISRC | カスタムID</th>
              <th class="youtube-claim-request-list__cell-policy">ポリシー</th>
              <th class="youtube-claim-request-list__cell-policy">時間</th>
            </tr>
          </thead>
          <tbody
            v-if="items && items.length > 0"
            class="youtube-list__tbody">
            <tr
              v-for="(item, index) in items"
              :key="item.id"
              @click.prevent="onRowClicked(item.videoId)">
              <td>
                <div style="display: flex">
                  <div style="font-size: 14px; font-weight: bold; margin: 12px 8px 12px 8px">
                    {{ index + 1 }}
                  </div>
                  <div style="text-align: left">
                    <div v-if="item.asset">
                      <b>{{ item.asset.metadata.title }}</b>
                      <span v-if="item.asset.metadata.artist">
                        - {{ item.asset.metadata.artist[0] }}
                      </span>
                    </div>
                    <div style="color: gray; font-size: 12px;">
                      {{ contentName(item.contentType) }}
                    </div>
                    <div
                      style="font-size: 12px; color: gray;">
                      申し立て日: {{ item.timeCreated | formatDate('YYYY/MM/DD HH:mm') }}
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <template v-if="item.asset">
                  <div>{{ item.asset.metadata.isrc }}</div>
                  <div v-if="item.asset.metadata.customId">{{ item.asset.metadata.customId }}</div>
                  <div v-else>-</div>
                </template>
              </td>
              <td>
                <div style="margin: 8px auto auto 12px;">
                  <div class="youtube-policy youtube-policy-header">
                    <div class="youtube-policy-cell-label">
                      収益化
                    </div>
                    <div class="youtube-policy-cell-value">
                      {{ item.requestPolicies.monetize }}
                    </div>
                  </div>
                  <div class="youtube-policy youtube-policy-header">
                    <div class="youtube-policy-cell-label">
                      トラッキング
                    </div>
                    <div class="youtube-policy-cell-value">
                      {{ item.requestPolicies.tracking }}
                    </div>
                  </div>
                  <div class="youtube-policy youtube-policy-header">
                    <div class="youtube-policy-cell-label">
                      ブロック
                    </div>
                    <div class="youtube-policy-cell-value">
                      {{ item.requestPolicies.block }}
                    </div>
                  </div>
                </div>
                <div style="text-align: right; color: gray;font-size: 12px;">
                  ({{ sourceName(item.origin.source) }})
                </div>
              </td>
              <td>
                <div style="margin: 8px auto auto 12px;">
                  <div class="youtube-policy youtube-policy-header">
                    <div class="youtube-policy-cell-label">
                      時間
                    </div>
                    <div class="youtube-policy-cell-value">
                      {{ durationSec(item) }}
                    </div>
                  </div>
                  <div class="youtube-policy youtube-policy-header">
                    <div class="youtube-policy-cell-label">
                      動画
                    </div>
                    <div class="youtube-policy-cell-value">
                      {{ videoDurationPercentage(item) }}
                    </div>
                  </div>
                  <div class="youtube-policy youtube-policy-header">
                    <div class="youtube-policy-cell-label">
                      参照
                    </div>
                    <div class="youtube-policy-cell-value">
                      {{ referenceDurationPercentage(item) }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

import moment from 'moment/moment'

export default {
  name: 'YouTubeClaimsClaimRequestTable',
  props: {
    video: {
      type: Object,
      required: true,
      default: () => {},
    },
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    title: {
      type: String,
      required: false,
      default: () => '',
    },
  },
  data() {
    return {
    }
  },
  computed: {
    moment() {
      return moment
    },
  },
  mounted() {
  },
  methods: {
    onRowClicked(id) {
      this.$emit('row-clicked', id)
    },
    toSeconds(sec) {
      return moment.utc(sec * 1000).format('mm:ss')
    },
    toPercentage(sec, total) {
      return `${((sec / total) * 100).toFixed(0)}%`
    },
    durationSec(item) {
      if (!item.matchInfo) {
        return '-'
      }
      const { totalMatch } = item.matchInfo ?? {}
      if (!totalMatch || !totalMatch.userVideoDurationSecs) {
        return '-'
      }
      return this.toSeconds(totalMatch.userVideoDurationSecs)
    },
    videoDurationPercentage(item) {
      if (!item.matchInfo || !this.video.duration) {
        return '-'
      }
      const { totalMatch } = item.matchInfo
      if (!totalMatch || !totalMatch.userVideoDurationSecs) {
        return '-'
      }
      return this.toPercentage(totalMatch.userVideoDurationSecs, this.video.duration)
    },
    referenceDurationPercentage(item) {
      if (!item.matchInfo || !item.reference) {
        return '-'
      }
      if (!item.reference) {
        return '-'
      }
      const { totalMatch } = item.matchInfo
      if (!totalMatch || !totalMatch.referenceDurationSecs) {
        return '-'
      }
      return this.toPercentage(totalMatch.referenceDurationSecs, item.reference.length)
    },
    sourceName(source) {
      switch (source) {
        case 'cmsUpload':
          return 'アップロード'
        case 'audioMatch':
          return '音声の一致'
        case 'descriptiveSearch':
          return '手動申し立て'
        case 'inProductShorts':
          return 'プロダクト内 - ショート'
        case 'melodyMatch':
          return 'メロディの一致'
        default:
          return source
      }
    },
    contentName(type) {
      switch (type) {
        case 'audio':
          return 'サウンドレコーディング'
        case 'audiovisual':
          return '動画'
        default:
          return type
      }
    },
  },
}
</script>

<style scoped>
.youtube-policy-cell-label {
  font-size: 12px;
  color: #666;
  width: 80px;
  text-align: right;
}
.youtube-policy-cell-value {
  font-size: 12px;
  color: #333;
  width: 50px;
  text-align: right;
}

</style>
